import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import {
  useSearchDispatch,
  useSearchState,
} from '../../../hooks/use_search_state';

import {
  bestMatchSort,
  highestPriceSort,
  lowestPriceSort,
  commissionSort,
  discountSort,
} from '../../../defines';
import FilterButton from './filter_button';
import ClearFiltersButton from './clear_filters_button';

export default function SortOnSale(props) {
  const {
    hideSort,
    hideOnSaleOnly,
    clearBtnClassName,
    houseKeeping,
  } = props;

  const {
    setSortOrder,
    setOnSaleOnly,
  } = useSearchDispatch();

  const {
    sortOrder,
    onSaleOnly,
  } = useSearchState();

  const doSort = useCallback((order) => {
    houseKeeping();
    setSortOrder(order);
  }, [houseKeeping, setSortOrder]);

  if (hideSort && hideOnSaleOnly) {
    return null;
  }

  return (
    <div className="snapgadget-search-facet-group snapgadget-search-facet-sort-sale">
      {
        hideSort
          ? null
          : <div className="snapgadget-search-facet">
            <h2>Sort</h2>
            <div className="snapgadget-search-facet-contents">
              <FilterButton selected={sortOrder === bestMatchSort} onClick={() => doSort(bestMatchSort)} name="Best Match" />
              <FilterButton selected={sortOrder === highestPriceSort} onClick={() => doSort(highestPriceSort)} name="Highest Price" />
              <FilterButton selected={sortOrder === lowestPriceSort} onClick={() => doSort(lowestPriceSort)} name="Lowest Price" />
              <FilterButton selected={sortOrder === commissionSort} onClick={() => doSort(commissionSort)} name="Highest Commission" />
              <FilterButton selected={sortOrder === discountSort} onClick={() => doSort(discountSort)} name="Best Discount" />
            </div>
          </div>
      }
      {
        hideOnSaleOnly
          ? null
          : <div className="snapgadget-search-facet">
            <h2>Sale</h2>
            <div>
              <label className="snapgadget-onsale-label">
                <input
                  type="checkbox"
                  className="snapgadget-facet-button"
                  checked={onSaleOnly}
                  onChange={() => {
                    houseKeeping();
                    setOnSaleOnly(!onSaleOnly);
                  }}
                />
              Only items on sale
              </label>
            </div>
          </div>

      }
      <div className="snapgadget-clear-filter-container">
        <ClearFiltersButton 
          clearBtnClassName={clearBtnClassName}
        />
      </div>
    </div>
  );
}

SortOnSale.propTypes = {
  hideSort: PropTypes.bool,
  hideOnSaleOnly: PropTypes.bool,
  clearBtnClassName: PropTypes.string,
  houseKeeping: PropTypes.func.isRequired,
};
